var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_327_1080)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_327_1080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9342 9.61455C17.823 9.59894 16.7494 10.0173 15.9418 10.7807L13.6104 13.1121L19.6447 19.1463L21.9762 16.815C22.7395 16.0074 23.1578 14.9339 23.1422 13.8227C23.1266 12.7115 22.6782 11.6502 21.8923 10.8644C21.1067 10.0786 20.0454 9.63019 18.9342 9.61455Z",
    fill: "#D7F4EE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6102 13.1121L10.7645 15.9579C10.0049 16.7697 9.59197 17.8457 9.6136 18.9573C9.63522 20.0688 10.0896 21.1281 10.8802 21.9098C11.6708 22.6913 12.7351 23.1338 13.8468 23.1427C14.9586 23.1518 16.0299 22.7266 16.833 21.9578L19.6445 19.1463L13.6102 13.1121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85693 12.8571C10.1706 12.8571 12.8569 10.1709 12.8569 6.85714C12.8569 3.54343 10.1706 0.857143 6.85693 0.857143C3.54322 0.857143 0.856934 3.54343 0.856934 6.85714C0.856934 10.1709 3.54322 12.8571 6.85693 12.8571Z",
    fill: "#D7F4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9416 10.7807C16.7492 10.0173 17.8227 9.59894 18.9339 9.61455C20.0451 9.63019 21.1064 10.0786 21.8923 10.8644C22.6781 11.6502 23.1264 12.7115 23.142 13.8227C23.1576 14.9339 22.7393 16.0074 21.9759 16.815L16.833 21.9578C16.0299 22.7266 14.9586 23.1518 13.8468 23.1427C12.7351 23.1338 11.6708 22.6913 10.8802 21.9098C10.0896 21.1281 9.63522 20.0688 9.6136 18.9573C9.59197 17.8457 10.0049 16.7697 10.7645 15.9579L15.9416 10.7807Z",
    stroke: "#00A988",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6104 13.1121L19.6447 19.1463",
    stroke: "#00A988",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85693 12.8571C10.1706 12.8571 12.8569 10.1709 12.8569 6.85714C12.8569 3.54343 10.1706 0.857143 6.85693 0.857143C3.54322 0.857143 0.856934 3.54343 0.856934 6.85714C0.856934 10.1709 3.54322 12.8571 6.85693 12.8571Z",
    stroke: "#00A988",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.856934 6.85714H12.8569",
    stroke: "#00A988",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_327_1080"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_327_1080"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicine);
export default __webpack_public_path__ + "static/media/medicine.b4938ccc8f15cd8d8642c71b85d53868.svg";
export { ForwardRef as ReactComponent };